const CORE_KEY = 'app-content-admin';
function generateKey(key) {
    return `${CORE_KEY}:${key}`;
}
export const LocalStorageHelper = {
    getItem(key) {
        return localStorage.getItem(generateKey(key)) ?? undefined;
    },
    setItem(key, value) {
        localStorage.setItem(generateKey(key), value);
    },
    removeItem(key) {
        localStorage.removeItem(generateKey(key));
    }
};
